var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _path2, _circle, _circle2, _path3, _circle3, _circle4, _path4, _circle5, _circle6, _path5, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRolesIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 161,
    viewBox: "0 0 197 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 71,
    width: 54,
    height: 54,
    fill: "white",
    stroke: "#465DD8",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 89,
    width: 46,
    height: 14,
    fill: "#D3ECE0",
    stroke: "#21A164",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 107,
    width: 46,
    height: 14,
    fill: "#9D3C88",
    fillOpacity: 0.12,
    stroke: "#9D3C88",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 93,
    width: 14,
    height: 2,
    fill: "white",
    stroke: "#21A164",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 82,
    width: 12,
    height: 2,
    fill: "white",
    stroke: "#465DD8",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 75.5,
    width: 7,
    height: 1,
    fill: "white",
    stroke: "#465DD8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 75.5,
    width: 7,
    height: 1,
    fill: "white",
    stroke: "#465DD8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 111,
    width: 14,
    height: 2,
    fill: "white",
    stroke: "#9D3C88",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 98.5,
    width: 7,
    height: 1,
    fill: "white",
    stroke: "#21A164"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 116.5,
    width: 7,
    height: 1,
    fill: "white",
    stroke: "#9D3C88"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 98.5,
    width: 7,
    height: 1,
    fill: "white",
    stroke: "#21A164"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 116.5,
    width: 7,
    height: 1,
    fill: "white",
    stroke: "#9D3C88"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 98.5,
    width: 7,
    height: 1,
    fill: "white",
    stroke: "#21A164"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 116.5,
    width: 7,
    height: 1,
    fill: "white",
    stroke: "#9D3C88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 76L85 77.7321L85 74.2679L88 76Z",
    fill: "#465DD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.653 82.1398L115.64 82.1532C115.249 82.5371 114.621 82.5348 114.232 82.1466C113.842 81.756 113.842 81.1229 114.232 80.7323C114.623 80.3418 115.256 80.3418 115.646 80.7323C116.035 81.1206 116.037 81.7488 115.653 82.1398ZM117.647 82.733C118.18 81.6179 117.984 80.2418 117.061 79.3181C115.889 78.1466 113.99 78.1466 112.818 79.3181C111.646 80.4897 111.646 82.3892 112.818 83.5608C113.742 84.4844 115.118 84.6799 116.233 84.1472L118.475 86.3892L119.889 84.975L117.647 82.733Z",
    fill: "#465DD8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30,
    cy: 131,
    r: 30,
    fill: "#9D3C88"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 131.5,
    r: 19.5,
    fill: "#9D3C88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.476 133.524L29.7496 137.25L26.0232 133.524C23.2304 133.645 21 135.93 21 138.75V139.125C21 140.16 21.8398 141 22.8749 141H36.6242C37.6593 141 38.4991 140.16 38.4991 139.125V138.75C38.4991 135.93 36.2688 133.645 33.476 133.524V133.524ZM21.5312 124.118L21.7812 124.177V126.458C21.5078 126.622 21.3125 126.907 21.3125 127.251C21.3125 127.579 21.4922 127.852 21.7461 128.02L21.1367 130.454C21.0703 130.723 21.2187 131 21.4336 131H23.0663C23.2811 131 23.4296 130.723 23.3632 130.454L22.7538 128.02C23.0077 127.852 23.1874 127.579 23.1874 127.251C23.1874 126.907 22.9921 126.622 22.7187 126.458V124.403L25.2967 125.024C24.9607 125.696 24.7498 126.446 24.7498 127.251C24.7498 130.012 26.988 132.25 29.7496 132.25C32.5112 132.25 34.7493 130.012 34.7493 127.251C34.7493 126.446 34.5423 125.696 34.2025 125.024L37.964 124.118C38.6749 123.946 38.6749 123.059 37.964 122.888L30.5269 121.091C30.0191 120.97 29.484 120.97 28.9762 121.091L21.5312 122.884C20.8242 123.056 20.8242 123.946 21.5312 124.118V124.118Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 167,
    cy: 116,
    r: 30,
    fill: "#21A164"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 116.5,
    r: 19.5,
    fill: "#21A164"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.75 116C169.512 116 171.75 113.762 171.75 111C171.75 108.238 169.512 106 166.75 106C163.988 106 161.75 108.238 161.75 111C161.75 113.762 163.988 116 166.75 116ZM170.25 117.25H169.598C168.73 117.648 167.766 117.875 166.75 117.875C165.734 117.875 164.773 117.648 163.902 117.25H163.25C160.352 117.25 158 119.602 158 122.5V124.125C158 125.16 158.84 126 159.875 126H173.625C174.66 126 175.5 125.16 175.5 124.125V122.5C175.5 119.602 173.148 117.25 170.25 117.25Z",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 110,
    cy: 30,
    r: 30,
    fill: "#465DD8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.5,
    cy: 30.5,
    r: 19.5,
    fill: "#465DD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.75 30C112.512 30 114.75 27.7617 114.75 25C114.75 22.2383 112.512 20 109.75 20C106.988 20 104.75 22.2383 104.75 25C104.75 27.7617 106.988 30 109.75 30ZM113.492 31.2734L111.625 38.75L110.375 33.4375L111.625 31.25H107.875L109.125 33.4375L107.875 38.75L106.008 31.2734C103.223 31.4063 101 33.6836 101 36.5V38.125C101 39.1602 101.84 40 102.875 40H116.625C117.66 40 118.5 39.1602 118.5 38.125V36.5C118.5 33.6836 116.277 31.4063 113.492 31.2734V31.2734Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 106.982,
    y1: 49.1871,
    x2: 102.982,
    y2: 70.1871,
    stroke: "#465DD8",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 120.506,
    y1: 96.1373,
    x2: 149.506,
    y2: 113.137,
    stroke: "#21A164",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 45.7127,
    y1: 125.042,
    x2: 75.7127,
    y2: 116.042,
    stroke: "#9D3C88",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesIllustration);
export default __webpack_public_path__ + "static/media/RolesIllustration.c28a3a63.svg";
export { ForwardRef as ReactComponent };